import { render, staticRenderFns } from "./AxMonitorElement.vue?vue&type=template&id=6d3b456b&scoped=true"
import script from "./AxMonitorElement.vue?vue&type=script&lang=ts"
export * from "./AxMonitorElement.vue?vue&type=script&lang=ts"
import style0 from "./AxMonitorElement.vue?vue&type=style&index=0&id=6d3b456b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b456b",
  null
  
)

export default component.exports